var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1440,
    height: 85,
    viewBox: "0 0 1440 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21067",
    "data-name": "Rectangle 21067",
    width: 1440,
    height: 85,
    transform: "translate(0 815)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11697",
    "data-name": "Rectangle 11697",
    width: 1440,
    height: 125,
    transform: "translate(0 716)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_31791",
    "data-name": "Mask Group 31791",
    transform: "translate(0 -815)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10989",
    "data-name": "Mask Group 10989",
    transform: "translate(0 86)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(0.479 732.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M1919.5,9.589c-86.66.365-178.049,22.178-265.2,19.911-95.6-2.485-186.34-12.621-281.965-10.394-63.864,1.489-125.811,11.239-187.049,20.788s-124.391.145-188.294,1.1c-12.04.179-35.466-.418-36.282-.519-.79-.043-1.92,0-1.92,0s-24.245.7-36.284.519c-63.9-.957-126.061-10.453-187.3-20S612.022,1.7,548.157.207C452.533-2.02,358.839,14.372,263.239,16.86,176.089,19.125,86.66,9.959,0,9.591V96H1919.5Z",
    fill: "#e8f3f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M1919.5,30.342c-40.53,1.623-141.6,17.012-256.078,19.751-86.955,2.081-197.631-5.707-300.092-3.965C1264.885,47.8,1232.941,66.184,1141.4,66.776c-50.446.326-139-3.372-183.971-3.372A1179.2,1179.2,0,0,1,733.853,41.47C674.346,29.591,609,15.355,545.164,13.914c-95.58-2.156-188.718,24.363-284.273,26.77C173.783,42.878,94.049,21.694,0,30.342",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_321",
    "data-name": "Ellipse 321",
    cx: 1.466,
    cy: 1.466,
    r: 1.466,
    transform: "translate(72.125 16.283)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_322",
    "data-name": "Ellipse 322",
    cx: 0.733,
    cy: 0.733,
    r: 0.733,
    transform: "translate(79.454 17.456)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M32.548,22.733a1.173,1.173,0,1,1-1.172-1.173A1.172,1.172,0,0,1,32.548,22.733Z",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_323",
    "data-name": "Ellipse 323",
    cx: 1.319,
    cy: 1.319,
    r: 1.319,
    transform: "translate(34.747 12.325)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_325",
    "data-name": "Ellipse 325",
    cx: 1.881,
    cy: 1.881,
    r: 1.881,
    transform: "translate(186.365 18.124)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_326",
    "data-name": "Ellipse 326",
    cx: 3.386,
    cy: 3.386,
    r: 3.386,
    transform: "translate(1375.859 25.806)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M468.254,16.117a1.5,1.5,0,0,1-1.5,1.5h-.005a1.5,1.5,0,1,1,0-3.005h0a1.5,1.5,0,0,1,1.505,1.495Z",
    fill: "#bfddd9",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M500.748,10.1a1.38,1.38,0,0,1-1.38,1.38h0a1.378,1.378,0,0,1-1.379-1.379h0a1.379,1.379,0,0,1,1.379-1.379h0a1.38,1.38,0,0,1,1.38,1.378Z",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M698.362,15.914a.687.687,0,0,1-.687.689h0a.688.688,0,0,1-.688-.688h0a.689.689,0,0,1,1.377,0Z",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M968.116,54.2a3.028,3.028,0,0,1-3.028,3.03h0a3.029,3.029,0,0,1-3.029-3.029h0a3.03,3.03,0,0,1,6.059,0Z",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_327",
    "data-name": "Ellipse 327",
    cx: 1.79,
    cy: 1.79,
    r: 1.79,
    transform: "translate(701.17 18.944)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_328",
    "data-name": "Ellipse 328",
    cx: 1.79,
    cy: 1.79,
    r: 1.79,
    transform: "translate(639.969 19.908)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 3.884,
    cy: 3.884,
    r: 3.884,
    transform: "translate(1169.622 44.794)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M1056.024,66.561a2.249,2.249,0,0,1-2.249,2.249h0a2.249,2.249,0,0,1,0-4.5h0A2.25,2.25,0,0,1,1056.024,66.561Z",
    fill: "#bfddd9",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_330",
    "data-name": "Ellipse 330",
    cx: 1.227,
    cy: 1.227,
    r: 1.227,
    transform: "translate(1091.37 64.309)",
    fill: "#bfddd9",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M944.761,47.043a1.635,1.635,0,1,1-1.635-1.635,1.635,1.635,0,0,1,1.635,1.635Z",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M831.545,57.674a3.475,3.475,0,0,1-6.951,0h0A3.476,3.476,0,0,1,828.07,54.2h0a3.475,3.475,0,0,1,3.475,3.475Z",
    fill: "#bfddd9",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M806.609,37.435a1.022,1.022,0,0,1-1.02,1.026h0a1.024,1.024,0,0,1-.006-2.048h.006A1.023,1.023,0,0,1,806.609,37.435Z",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_331",
    "data-name": "Ellipse 331",
    cx: 1.892,
    cy: 1.892,
    r: 1.892,
    transform: "translate(563.082 7.263)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_332",
    "data-name": "Ellipse 332",
    cx: 3.348,
    cy: 3.348,
    r: 3.348,
    transform: "translate(1253.265 53.448)",
    fill: "#bfddd9",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M63.815,31.171a1.979,1.979,0,1,1-1.979-1.979h0a1.98,1.98,0,0,1,1.979,1.979Z",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_333",
    "data-name": "Ellipse 333",
    cx: 0.99,
    cy: 0.99,
    r: 0.99,
    transform: "translate(49.712 29.687)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M86.331,30.676a1.856,1.856,0,0,1-1.856,1.856h0a1.856,1.856,0,0,1-1.856-1.856h0a1.856,1.856,0,0,1,3.712,0Z",
    fill: "#bfddd9",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_334",
    "data-name": "Ellipse 334",
    cx: 2.227,
    cy: 2.227,
    r: 2.227,
    transform: "translate(108.97 21.398)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M1474.341,43.491a4.248,4.248,0,1,1-4.248-4.249A4.247,4.247,0,0,1,1474.341,43.491Z",
    fill: "#bfddd9",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_335",
    "data-name": "Ellipse 335",
    cx: 1.983,
    cy: 1.983,
    r: 1.983,
    transform: "translate(168.244 34.428)",
    fill: "#bfddd9",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M450.1,37.261a6.231,6.231,0,0,1-6.231,6.231h0a6.231,6.231,0,0,1-6.231-6.231h0a6.231,6.231,0,0,1,6.231-6.231h0a6.231,6.231,0,0,1,6.231,6.231Z",
    fill: "#bfddd9",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M723.167,53.4a6.231,6.231,0,0,1-6.231,6.231h0a6.231,6.231,0,0,1-6.231-6.231h0a6.231,6.231,0,0,1,6.231-6.231h0a6.231,6.231,0,0,1,6.231,6.231Z",
    fill: "#bfddd9",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M1149.891,59.635a4.248,4.248,0,0,1-4.248,4.248h0a4.248,4.248,0,1,1,4.249-4.249Z",
    fill: "#bfddd9",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_336",
    "data-name": "Ellipse 336",
    cx: 2.227,
    cy: 2.227,
    r: 2.227,
    transform: "translate(1729.496 30.924)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M1522.382,43.491a1.855,1.855,0,1,1-1.855-1.856A1.855,1.855,0,0,1,1522.382,43.491Z",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M1803.945,34.428a1.979,1.979,0,0,1-1.979,1.979h0a1.979,1.979,0,0,1-1.979-1.979h0a1.979,1.979,0,0,1,1.978-1.98h0a1.979,1.979,0,0,1,1.979,1.979Z",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_337",
    "data-name": "Ellipse 337",
    cx: 3.386,
    cy: 3.386,
    r: 3.386,
    transform: "translate(1893.409 31.991)",
    fill: "#bfddd9",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M1883.728,25.806a4.247,4.247,0,0,1-4.248,4.248h0a4.247,4.247,0,0,1-4.248-4.248h0a4.248,4.248,0,0,1,4.247-4.249h0a4.248,4.248,0,0,1,4.248,4.248Z",
    fill: "#bfddd9",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_338",
    "data-name": "Ellipse 338",
    cx: 1.466,
    cy: 1.466,
    r: 1.466,
    transform: "translate(1824.731 33.628)",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M1816.421,48.516a1.979,1.979,0,0,1-1.979,1.979h0a1.979,1.979,0,0,1-1.979-1.979h0a1.979,1.979,0,0,1,1.979-1.979h0a1.98,1.98,0,0,1,1.98,1.978Z",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M1838.936,48.021a1.856,1.856,0,0,1-1.856,1.856h0a1.855,1.855,0,0,1-1.855-1.855h0a1.855,1.855,0,0,1,1.853-1.855h0a1.856,1.856,0,0,1,1.856,1.854Z",
    fill: "#bfddd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M1919.48,29.841c-14.086.565-35.3,2.772-62.162,5.566-50.3,5.232-119.193,12.4-193.908,14.186-43.212,1.038-91.842-.357-143.324-1.83-51.734-1.48-105.232-3.011-156.765-2.135-49.24.837-81.953,5.867-113.59,10.73-32.185,4.948-62.585,9.622-108.335,9.919-27.317.179-65.572-.821-102.559-1.786-31.268-.816-60.8-1.586-81.408-1.586A1181.639,1181.639,0,0,1,733.951,40.98q-7.711-1.539-15.552-3.122C661.93,26.488,603.536,14.732,545.175,13.414c-51.907-1.177-103.968,6.234-154.311,13.394-42.435,6.035-86.316,12.276-129.986,13.376-37.887.95-75.4-2.579-111.684-5.995C101.781,29.723,52.759,25.118,0,29.849v1c52.7-4.736,101.705-.132,149.1,4.331,36.311,3.419,73.864,6.953,111.8,6,43.728-1.1,87.638-7.346,130.1-13.386,50.3-7.154,102.32-14.555,154.148-13.383C603.426,15.729,661.774,27.477,718.2,38.838q7.837,1.578,15.556,3.123A1182.671,1182.671,0,0,0,957.428,63.9c20.6,0,50.123.77,81.383,1.586,34.1.889,69.274,1.806,95.985,1.806,2.263,0,4.471-.006,6.606-.02,45.824-.3,76.259-4.977,108.482-9.931,31.6-4.858,64.282-9.882,113.455-10.718,51.511-.878,105,.654,156.719,2.134,51.5,1.475,100.138,2.863,143.376,1.831C1738.188,48.8,1807.1,41.635,1857.422,36.4c26.842-2.792,48.043-5,62.1-5.56Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundBottom);
export default __webpack_public_path__ + "static/media/background-bottom.76edbaa3fe91ffc9ee36a00eaebe0bab.svg";
export { ForwardRef as ReactComponent };